import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Smooth-scrolls to any element matching the URL hash on route change
export default function ScrollToHash() {
  const { hash, pathname } = useLocation();
  useEffect(() => {
    if (!hash) return;
    const id = hash.replace(/^#/, "");
    // Wait one frame so the target page mounts first
    const t = setTimeout(() => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 250);
    return () => clearTimeout(t);
  }, [hash, pathname]);
  return null;
}
